"use strict";

import scrollCheckSp from "./scrollCheckSp.js";
import headerFix from "./functions/headerFix.js";
import common from "./functions/common.js";
import smooth_scroll from "./functions/smooth_scroll_for_whitening.js";
import smoothscroll from 'smoothscroll-polyfill';

headerFix();
common();
smoothscroll.polyfill();
smooth_scroll();

$(() => {
  const a = new scrollCheckSp();
  a.isScrollDown();

  if ($(window).scrollTop() > 0) {
    $(".section-table").removeClass("is-top");
  } else {
    $(".section-table").addClass("is-top");
  }

  $(window).on("scroll", function () {
    if ($(this).scrollTop() > 0) {
      $(".section-table").removeClass("is-top");
    } else {
      $(".section-table").addClass("is-top");
    }
  });


  let sec_about_top;
  let sec_structure_top;
  let sec_menu_top;
  let sec_feature_top;
  let sec_flow_top;
  let sec_voice_top;
  let sec_faq_top;

  $(".section-table__inner a").on('click', function () {
    if (!$(this).parent().hasClass("is-current")) {
      $(".section-table__inner li:not(.is-current)").toggleClass("is-open");
      $(".js-section-table-button").toggleClass("is-open");
    }
    if ($(".js-section-table-button").hasClass("is-open")) {
      $(".section-table__inner li").removeClass("is-open");
    }
  });
  $(".js-section-table-button").on('click', function () {
    $(this).toggleClass("is-open");
    $(this).prev().children('.is-hidden').toggleClass('is-open');
  });
  const reset_section_table = () => {
    $(".section-table__inner li").addClass("is-hidden");
    $(".section-table__inner li").removeClass("is-open");
    $(".section-table__inner li").removeClass("is-current");
    if ($(".js-section-table-button").hasClass("is-open")) {
      $(".section-table__inner li").addClass("is-open");
    }
  }

  const wid = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  // if ($(".header-about").length === 0) {
  if (wid < 768) {
    $(window).on("scroll", function () {
      sec_about_top = $('#about').offset().top;
      sec_structure_top = $('#structure').offset().top;
      sec_menu_top = $('#menu').offset().top;
      sec_feature_top = $('#feature').offset().top;
      sec_flow_top = $('#flow').offset().top;
      sec_voice_top = $('#voice').offset().top;
      sec_faq_top = $('#faq').offset().top;
      if ($(this).scrollTop() >= sec_faq_top - 10) {
        reset_section_table();
        $(".section-table__inner li:nth-child(7)").removeClass("is-hidden");
        $(".section-table__inner li:nth-child(7)").addClass("is-current");
        $(".section-table__inner li:nth-child(1)").addClass("is-not-current");
      } else if ($(this).scrollTop() >= sec_voice_top - 10) {
        reset_section_table();
        $(".section-table__inner li:nth-child(6)").removeClass("is-hidden");
        $(".section-table__inner li:nth-child(6)").addClass("is-current");
        $(".section-table__inner li:nth-child(1)").addClass("is-not-current");
      } else if ($(this).scrollTop() >= sec_flow_top - 10) {
        reset_section_table();
        $(".section-table__inner li:nth-child(5)").removeClass("is-hidden");
        $(".section-table__inner li:nth-child(5)").addClass("is-current");
        $(".section-table__inner li:nth-child(1)").addClass("is-not-current");
      } else if ($(this).scrollTop() >= sec_feature_top - 10) {
        reset_section_table();
        $(".section-table__inner li:nth-child(4)").removeClass("is-hidden");
        $(".section-table__inner li:nth-child(4)").addClass("is-current");
        $(".section-table__inner li:nth-child(1)").addClass("is-not-current");
      } else if ($(this).scrollTop() >= sec_menu_top - 10) {
        reset_section_table();
        $(".section-table__inner li:nth-child(3)").removeClass("is-hidden");
        $(".section-table__inner li:nth-child(3)").addClass("is-current");
        $(".section-table__inner li:nth-child(1)").addClass("is-not-current");
      } else if ($(this).scrollTop() >= sec_structure_top - 10) {
        reset_section_table();
        $(".section-table__inner li:nth-child(2)").removeClass("is-hidden");
        $(".section-table__inner li:nth-child(2)").addClass("is-current");
        $(".section-table__inner li:nth-child(1)").addClass("is-not-current");
      } else if ($(this).scrollTop() >= sec_about_top - 10) {
        reset_section_table();
        $(".section-table__inner li:nth-child(1)").removeClass("is-current");
        $(".section-table__inner li:nth-child(1)").removeClass("is-hidden");
        $(".section-table__inner li:nth-child(1)").addClass("is-current");
      }
      if ($(this).scrollTop() >= sec_about_top - 10) {
        $(".section-table").addClass("is-fixed");
        $(".section-table").removeClass("is-hidden");
      } else {
        $(".section-table").removeClass("is-fixed");
        $(".section-table").addClass("is-hidden");
      }
    });
  }

  $(".js-click-open").on('click', function () {
    $(this).parent().next().css('display', 'block');
    $(this).parent().css('display', 'none');
  });
});
